<template>
	<div>
		<div>
			<div class="float-right">
				<button @click="save" class="btn btn-primary mr-2">{{ $t('save') }}</button>
				<button @click="cancel" class="btn btn-secondary">{{ $t('cancel') }}</button>
			</div>
			<h1>{{ $t('section') }}</h1>

		</div>

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('form-saved') }}</div>
		</div>

		<div>
			<fieldset>
				<div class="form-group">
					<label>{{ $t('name') }}</label>
					<input class="form-control" v-model="item.name" :placeholder="$t('name')">
				</div>
			</fieldset>
			<draggable
				v-model="item.procedures"
				handle=".card-header"
				ghost-class="vuedraggable-ghost"

			>
				<div v-for="(page, pageIndex) in item.procedures" :key="pageIndex" class="panel panel-default">

					<div
						class="card mb-3"
						:sort="true"
					>
						<div class="card-header">
							<a class="btn btn-light btn-xs move mr-1"
								style="margin: 0 0 0"
								data-toggle="tooltip" data-placement="top" :title="$t('drag-to-reorder')"
								><b-icon icon="arrows-move" width="1em" height="1em"></b-icon></a>
							<label style="cursor:pointer;">{{page.caption}}</label>

							<div class="float-right">
								<a class="btn btn-secondary btn-sm mr-1"
									@click="editProcedure(page.id)"><b-icon icon="pencil" width="1em" height="1em"></b-icon> {{ $t('edit') }}
								</a>
								<a class="btn btn-danger btn-sm"
									@click="removeProcedure(page.id)"><b-icon icon="trash" width="1em" height="1em"></b-icon> {{ $t('remove') }}
								</a>
							</div>

						</div>
					</div>
				</div>
			</draggable>
			<div class="float-right">
				<button @click="save" class="btn btn-secondary mr-2">{{ $t('save') }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
	components: {
		draggable,
	},
	data() {
		return {
			saved: false,
			item: {
				id: 'new' ,
				name: '' ,
				position: 0,
				procedures: []
			}
		}
	},
	mounted() {
		if(this.$route.params.itemid){
			this.getItem();
		}
	},
	methods: {
		getItem(){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/section/${this.$route.params.itemid}`, {
				data: {
				}
			})
			.then((json) => {
				if(json.status == 'SUCCESS'){
					this.item = json.result;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		save() {
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/section/${this.item.id}`, {
				method: "post",
				data: {
					save: true ,
					section: this.item
				}
			})
			.then((json) => {
				if(json.status == 'SUCCESS'){
					this.item = json.result;
					this.saved = true;
					// bad ux IMHO when this doesn't go away as no feedback on subsequent saves
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});

        },
        cancel() {
			this.$router.go(-1);
        },
		editProcedure(id) {
			this.$router.push(`/settings/interfaceeditor/procedures/edit/${id}`);
		},
		removeProcedure(id){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/deleteprocedure`, {
				data: {
					id: id ,
					section_id: this.item.id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.getItem();
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
	},
	computed: {

	}
};
</script>
